export interface Heading {
  text: string;
  level: number;
  id: string;
}

export interface UseCase {
  title: string;
  description: string;
  icon?: string;
  id: string;
}

export const extractHeadings = (content: string): Heading[] => {
  const headingRegex = /^(#{1,3})\s+(.+)$/gm;
  const headings: Heading[] = [];
  let match = headingRegex.exec(content);
  
  while (match !== null) {
    const level = match[1].length;
    const text = match[2];
    const id = text.toLowerCase().replace(/[^\da-z]+/g, '-');
    if (level === 2) {
      headings.push({ text, level, id });
    }
    match = headingRegex.exec(content);
  }
  
  return headings;
};

export const extractUseCases = (content: string): UseCase[] => {
  const useCasesMatch = content.match(/## (?:Real-time Use Cases|Who Benefits)([\S\s]*?)(?=##|$)/);
  if (!useCasesMatch) return [];

  const useCasesSection = useCasesMatch[1];
  const bulletPoints = useCasesSection.split('\n').filter((line) => line.trim().match(/^-\s+.+\s+-\s+.+/));

  return bulletPoints
    .map((line, index) => {
      const match = line.match(/^-\s+(.+?)\s+-\s+(.+)/);
      if (!match) return null;

      return {
        title: match[1].trim().replace(/\*\*/g, ''),
        description: match[2].trim(),
        id: `use-case-${index}`,
      };
    })
    .filter(Boolean) as UseCase[];
};
